import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage2
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuGruposUsuarios/pagesGruposDeUsuario/PermissoesDeAcessoAoSistema.css'

function VinculoUnidade() {
  let id = useParams<{ IdPessoa: string }>()
  const [searchTerm, setSearchTerm] = useState('')
  useEffect(() => {
    setSearchTerm(sessionStorage.searchTerm)
  })
  var user = authService.getCurrentUser()
  const history = useNavigate()
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdVinculoPessoa: 0,
    IdPessoa: id['IdPessoa'],
    IdEmpresa: user[0].IdEmpresa,
    IdUnidade: 0,
    vcpStatus: 1,
    vcpCriadoPor: user[0].pesEmail,
    vcpCriadoEm: newDate,
    vcpAlteradoPor: user[0].pesEmail,
    vcpAlteradoEm: newDate,
    vcpCodigoGUID: '',
    vcpGUIDOrigem: ''
  })
  const [unidades, setUnidades] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL + '/api/v1/vinculo/list/' + id['IdPessoa']
      )
      .then(response => {
        setUnidades(response.data)
        if (sessionStorage.IdUnidade === undefined) {
          sessionStorage.IdUnidade = response.data[0].IdUnidade
          sessionStorage.uniRazaoSocial = response.data[0].uniRazaoSocial
          window.location.reload()
        }
      })
  }, [])
  function handleUnidadeChange(event: any, unidade: any) {
    if (unidade.IdVinculoPessoa) {
      let status = 0
      if (event.target.checked) {
        status = 1
      }
      campos.vcpStatus = status
      setCampos(campos)
      event.preventDefault()
      axios
        .put(
          process.env.REACT_APP_API_URL +
          '/api/v1/vinculo/' +
          unidade.IdVinculoPessoa,
          campos
        )
        .then(response => {
          window.location.reload()
        })
    } else {
      let status = 0
      if (event.target.checked) {
        status = 1
      }
      campos.vcpStatus = status
      campos.IdUnidade = unidade.IdUnidade
      setCampos(campos)
      event.preventDefault()
      axios
        .post(process.env.REACT_APP_API_URL + '/api/v1/vinculo', campos)
        .then(response => {
          window.location.reload()
        })
    }
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage2>Vinculo com Unidades</TitlePage2>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fpesquisa"
              value={sessionStorage.searchTerm}
              onChange={event => {
                setSearchTerm(event.target.value)
                sessionStorage.searchTerm = event.target.value
              }}
            />
          </div>
        </div>

        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Vinculo</p>
              </th>
              <th>
                <p className="ttlTbl">Unidade</p>
              </th>
              <th>
                <p className="ttlTbl">Observação</p>
              </th>
            </thead>
            <tbody>
              {unidades
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.uniNome.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(unidade => (
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!unidade.vcpStatus}
                        onChange={event => {
                          handleUnidadeChange(event, unidade)
                        }}
                      />
                    </td>
                    <td><p>{unidade.uniNome}</p></td>
                    <td>
                      <p className="Space">{unidade.uniObservacoes}</p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        <NavDireita />
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default VinculoUnidade
